import React, {FC} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {ProfileHeader} from './ProfileHeader'

const ProfileHeaderWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>My Profile</PageTitle>
      <ProfileHeader />
    </>
  )
}

export {ProfileHeaderWrapper}

